
/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as Utils from '@Cyclope-Utils/index';
import {IncidentstmdLoadedActionFail, IncidentstmdLoadedActionInProgress, IncidentstmdLoadedActionSuccess} from '@tunnel-store/index';
import * as Lodash from 'lodash';
import {Dispatch} from 'redux';

/**
 * @function IncidentstmdLoadedActionCreator
 * @param {}
 * @return {Promise<any>}  Promise
 */
export function IncidentstmdLoadedActionCreator(): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(IncidentstmdLoadedActionInProgress());

            await Utils.findTMD()  // à corriger la fonction
            .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');
        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('application/json') !== -1) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }
            response.json().then(
                (data: any) => dispatch(IncidentstmdLoadedActionSuccess(
                    data)));  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(IncidentstmdLoadedActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(IncidentstmdLoadedActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                    dispatch(IncidentstmdLoadedActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                    Utils.fetchLogs(error.url,error.message,error.status,error.headers)
                })
  }
}


export function IncidentstmdLoadedAction(): (dispatch: Dispatch<any>, {}) =>
    Promise<any> {
  return async (dispatch: Dispatch<any>) => {
    return await Utils
        .findTMD()  // à corriger la fonction
        .then((response: any) => {
          if (response.ok) {
            if (response.status === 200) {
              return response.json().then((data: any) => {
                if (!Lodash.isUndefined(data) && !Lodash.isEmpty(data)) {
                  return true;
                } else {
                  return false;
                }  // État du state : resultat final
              })
            }

          } else {
            throw ({
              message: response.statusText,
              status: response.status,
              url: response.url,
              headers: response.headers
            });
          }
        })
        .catch((error: any) => {
          /* { // État du state : échec  }*/
          Utils.fetchLogs(error.url, error.message, error.status, error.headers)
          return false;
        })
  }
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/lapi-tmd/incidents-tmd/index.ts